
export const getCityName = async () => {
  if (!("geolocation" in navigator)) {
    return "Geolocation not supported";
  }

  const position = await new Promise((resolve, reject) => {
    navigator.geolocation.getCurrentPosition(resolve, reject);
  });

  const latitude = position.coords.latitude;
  const longitude = position.coords.longitude;
  try {
    const response = await fetch(`https://nominatim.openstreetmap.org/reverse?lat=${latitude}&lon=${longitude}&format=json`);
    const data = await response.json();
    return data.address.city || data.address.town || data.address.village || "Unknown location";
  } catch (error) {
    return 'Unknown (Error #0)';
  }
}